import {
  $convertToMarkdownString,
  CHECK_LIST,
  TRANSFORMERS,
} from '@lexical/markdown';

import { useEffect } from 'react';

import { MENTION_TRANSFORMER } from '@/components/editor/MentionPlugin/MentionPlugin';
import { TICKET_TRANSFORMER } from '@/components/editor/TicketPlugin/TicketPlugin';
import { PLACEHOLDER_TICKET_TRANSFORMER } from '@/components/editor/TicketPlugin/PlaceholderTicketNode';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

export function MarkdownExportPlugin({
  onMarkdownChange,
}: {
  onMarkdownChange: (markdown: string) => void;
}) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        const markdown = $convertToMarkdownString([
          CHECK_LIST,
          ...TRANSFORMERS,
          MENTION_TRANSFORMER,
          TICKET_TRANSFORMER,
          PLACEHOLDER_TICKET_TRANSFORMER,
        ]);
        onMarkdownChange(markdown);
      });
    });
  }, [editor, onMarkdownChange]);

  return null;
}
